import Vue from "vue";
import App from "./App.vue";
// import vuetify from "./plugins/vuetify";
import VueSweetalert2 from "vue-sweetalert2";
import moment from "moment";
// import cognitoAuth from "./cognito";
// import Amplify, { Auth } from "aws-amplify";
// import cognitoConfig from "./amplifyCognito/index";
import router from "./router";
import store from "./store";
import { domain, clientId } from "../auth_config.json";
import { Auth0Plugin } from "./auth";
import Croppa from "vue-croppa";
import "vue-croppa/dist/vue-croppa.css";
import "sweetalert2/dist/sweetalert2.min.css";
import VueApexCharts from "vue-apexcharts";
import "./quasar";
import * as VueGoogleMaps from "vue2-google-maps";
import VCalendar from "v-calendar";
import "./registerServiceWorker";
import "vue-json-pretty/lib/styles.css";

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});

Vue.config.productionTip = false;

localStorage.setItem("currentUser", JSON.stringify({}));
localStorage.setItem("currentUserData", JSON.stringify({}));

Vue.directive("clickable", {
  inserted: function (el) {
    el.style.cursor = "pointer";
  }
});

Vue.prototype.$moment = moment;

Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

Vue.use(VueSweetalert2);

// Vue.use(VueQrcodeReader);
Vue.use(Croppa);

Vue.use(moment);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyA4Z1gufJy4sBnc8RCLq1lT9Edc1pbd06w",
    libraries: "places" // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  }

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
});

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  componentPrefix: "vc" // ...other defaults
});

// Vue.use(ApexCharts);

// Vue.use(TiptapVuetifyPlugin, {
//   // the next line is important! You need to provide the Vuetify Object to this place.
//   vuetify, // same as "vuetify: vuetify"
//   // optional, default to 'md' (default vuetify icons before v2.0.0)
//   iconsGroup: "mdi"
// });

Vue.filter("momentFromNow", function (value) {
  return moment
    .utc(value)
    .local()
    .fromNow();
});

Vue.filter("momentFormat", function (value) {
  return moment
    .utc(value)
    .local()
    .format("DD-MMM, YYYY h:mma");
});
Vue.filter("splitCamelCase", function (value) {
  return value.replace(/([a-z])([A-Z])/g, "$1 $2");
});

Vue.filter("initials", function (value) {
  return value
    .split(" ")
    .map(n => n[0])
    .join(" ");
});

new Vue({
  router,
  store,
  head: {
    meta: [
      {
        name: "viewport",
        content:
          "width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover"
      }
    ]
  },
  beforeCreate() {
    this.$store.dispatch("settings/setFullLoaderState", true);
    this.$store.dispatch("settings/loadSiteData").then(() => {
      this.$store.dispatch("settings/getAppID").then(() => {
        this.$store.dispatch("auth/initAuth");
        this.$store.dispatch("settings/checkOnlineStatus");
        this.$store.dispatch("settings/loadDefaultDateRange");
        setInterval(() => {
          this.$store.dispatch("auth/initAuth");
        }, 300000);
      });
    });

    // this.$store.dispatch("setFullLoaderState", true);
    // this.$store.dispatch("loadSiteData").then(() => {
    //     this.$store.dispatch("initAuth");
    // });
  },
  render: h => h(App)
}).$mount("#app");
